const LineSpacer = () => {
    return <div style={{width: '100%', height: '1px', background: 'rgba(0,0,0, 0.1)', flex: '1'}}/>
}

export default LineSpacer